var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.182,
    height: 41.217,
    viewBox: "0 0 39.182 41.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1598",
    x: 0,
    y: 0,
    width: 39.182,
    height: 41.217,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9665",
    "data-name": "Group 9665",
    transform: "translate(4.5 3.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9660",
    "data-name": "Group 9660",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -3.5)",
    filter: "url(#Rectangle_1598)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1598-2",
    "data-name": "Rectangle 1598",
    width: 30.182,
    height: 32.217,
    rx: 4,
    transform: "translate(4.5 3.5)",
    fill: "#040227"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9661",
    "data-name": "Group 9661",
    transform: "translate(4.147 10.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7421",
    "data-name": "Path 7421",
    d: "M24.924,21.146l-2.282-1.141-1.886-.943a.528.528,0,0,0-.505.026.5.5,0,0,0-.25.438v4.168a.52.52,0,0,0,.245.443.528.528,0,0,0,.276.078.536.536,0,0,0,.234-.057l4.168-2.084a.515.515,0,0,0,.287-.464A.509.509,0,0,0,24.924,21.146Zm-3.882,1.7V20.37l2.48,1.24Z",
    transform: "translate(-11.14 -15.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7422",
    "data-name": "Path 7422",
    d: "M13.939,13h-.12c-.026,0-.047.005-.073.005-5.83.109-10.421,5.164-10.619,5.377a.518.518,0,0,0,0,.693c.2.224,4.892,5.388,10.811,5.388h.12c.026,0,.047-.005.073-.005,5.83-.109,10.421-5.164,10.619-5.377a.518.518,0,0,0,0-.693C24.553,18.164,19.858,13,13.939,13Zm-9.7,5.731a18.951,18.951,0,0,1,4.986-3.538,5.912,5.912,0,0,0-1.193,3.569,6.193,6.193,0,0,0,1.271,3.543A19.03,19.03,0,0,1,4.243,18.731ZM14.4,23.4c-.135.005-.271.021-.412.021-.063,0-.13-.005-.193-.005-.089,0-.182-.01-.271-.01a4.675,4.675,0,0,1-.042-9.337c.151-.01.3-.026.453-.026h.042c.141,0,.287.01.427.021a4.694,4.694,0,0,1,4.4,4.679A4.64,4.64,0,0,1,14.4,23.4Zm4.267-1.136a5.844,5.844,0,0,0,1.183-3.522V18.7a6.15,6.15,0,0,0-1.282-3.548,18.907,18.907,0,0,1,5.075,3.58A19.05,19.05,0,0,1,18.665,22.264Z",
    transform: "translate(-2.995 -13)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.7e91a9a67abac7d5a29c4200bf4bac6f.svg";
export { ForwardRef as ReactComponent };